var exports = {
  "R3": "TimestampRenderer.module__tooltipContainer___dU9pLX",
  "Mp": "TimestampRenderer.module__tooltipFullDateTime___dU9pLX",
  "fv": "TimestampRenderer.module__tooltipRelativeTime___dU9pLX",
};

module.exports = exports;
